import {RealTimeInfo} from "@/entity/RealTimeInfo";
import {Base} from "@/dto/Base";
import {Page} from "@/oauth/Page";
import RealTimeInfoReq from "@/dto/RealTimeInfoReq";

export class RealTimeInfoReqDto{
    public static url = '/api';
    public static async queryRealList(realTimeInfoReq: RealTimeInfoReq): Promise<RealTimeInfoReq> {
        const response = await Base.postWithToken(this.url+'/queryRealList',realTimeInfoReq) as any;
        const real = response.data as RealTimeInfoReq;
        return real;

    //     if (response.resCode==0){
    //         const real = response.data as RealTimeInfo[];
    //         return real;
    //     }else if (response.resCode==1){
    //         alert('kong')
    //     }
    //     return response;
     }
}
